<template>
  <div id="app">
    <el-container>

      <!-- 头部菜单 -->
      <el-header class="page-header">
        <MenuBar />
      </el-header>

      <el-main class="page-main">
        <router-view />
      </el-main>

      <el-footer class="page-footer" height="40px">
        <a href="https://beian.miit.gov.cn">粤ICP备2023036864号</a>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import MenuBar from './components/page/MenuBar.vue'
import { ChatUserAPI } from './api/user'

export default {
  name: 'app',
  components: {
    MenuBar
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    refreshUserInfo() {
      if (this.isLogin) {
        ChatUserAPI.info().then(res => {
          console.info("refresh success")
          this.$store.commit("saveUserInfo", res)
        }).catch(res => {
          console.info("refresh failed")
          this.$store.commit("cleanUserInfo")
        })
      }
    }
  },
  created() {
    if (window.location.href.indexOf('/#') > -1) {
      window.location.href = window.location.href.replace('/#', '');
    }
    this.$store.commit("loadUserInfo")
  },
  mounted() {
    this.refreshUserInfo()
  }
}
</script>

<style>
@import url("//unpkg.com/element-ui@2.15.7/lib/theme-chalk/index.css");

body {
  margin: 0;
  min-width: 400px;
  width: 100%;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

#app {
  margin: 0;
  width: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.page-header {
  text-align: center;
  line-height: 60px;
  padding: 0px;
  background-color: #639;
}

.page-footer {
  text-align: center;
  line-height: 40px;
}

.page-footer a {
  font-size: 12px;
  color: #666;
  text-decoration: none;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.page-main {
  background-color: rgba(255, 255, 255, 0.932);
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue